import React, { lazy, Suspense, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import Preloader from "../Miscellaneous/Preloader";

const companyComponents = {
    "about-us": lazy(() => import("./Company1")),
    "join-Our-team": lazy(() => import("./Company2")),
};

const DynamicCompany = () => {
    const { companyName } = useParams();
    const location = useLocation();

    useEffect(() => {
        requestAnimationFrame(() => {
            window.scrollTo({ top: 0, behavior: 'auto' });
        });
    }, [location.pathname]);

    const DecodedName = decodeURIComponent(companyName);

    const Component = companyComponents[DecodedName];

    return (
        <Suspense fallback={<Preloader />}>
            {Component ? <Component /> : <div>Company screen not found</div>}
        </Suspense>
    );
};

export default DynamicCompany;
